<script>
/* eslint-disable new-cap,vue/require-default-prop,vue/require-prop-type-constructor */
import { binMethods, serviceMethods, } from '@state/helpers'
import AddServiceBin from './mutations/add-service-bin'
// import parseDateMomentJS from '../utils/format-date'
// import store from '@state/store'

export default {
  name: 'ServiceBins',
  components:{
    AddServiceBin
  },
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'ServiceBins',
    meta: [{ name: 'ServiceBins', content: 'serviceBins' }],
  },
  props: {
    bin: null,
    serviceId: null,
  },
  data() {
    return {
      search: '',
      binHeaders: [
        { text: 'Id', value: 'id' },
        { text: 'Type', value: 'bin.description' },
        { text: 'Capacity', value: 'bin.capacity' },
        { text: 'Price', value: 'price' },
        { text: 'Extra Price', value: 'extra_price' },
        { text: 'Maintenance Fee', value: 'weekly_maintenance_fee' },
        { text: 'Actions', value: 'name', sortable: false },
      ],
      binDescriptions:[],
      allTheBins:[],
      updatedBinValue: {},
      newBin: false,
      editBin: false,
      removeBin: false,
      dateDialog: false,
      dictionary: {
        attributes: {
          // email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          // name: {
          //   required: () => 'Name can not be empty',
          //   max: 'The name field may not be greater than 10 characters',
          //   // custom messages
          // },
          select: {
            required: 'Select field is required',
          },
        }
      },
      addCollection: false,
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    let bins = this.$store.state.bins.objects

    for (let i in bins) {
      let formObj = bins[i];
      // console.log(formObj)
      this.binDescriptions.push(formObj.description)
      this.allTheBins.push(bins[i])
    }

    // console.log('bins', this.bin)
  },
  methods: {
    ...serviceMethods, ...binMethods,
    submit() {
      this.$validator.validateAll()
      this.createNewCollection()
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    updateBin(selectedBin){
      // console.log(selectedBin)
      this.updatedBinValue = selectedBin

      this.updatedBinValue.binIdentifier = this.updatedBinValue.bin_identifier
      this.updatedBinValue.castorsStatus = this.updatedBinValue.castors
      this.updatedBinValue.padlocksStatus = this.updatedBinValue.padlocks
      this.updatedBinValue.chargePerLitreStatus = this.updatedBinValue.chargePerLitre
      this.updatedBinValue.chargePerTonneStatus = this.updatedBinValue.chargePerTonne
      this.updatedBinValue.extraPrice = this.updatedBinValue.extra_price > 0 ? this.updatedBinValue.extra_price / 100 : this.updatedBinValue.extra_price
      this.updatedBinValue.priceFormatted = this.updatedBinValue.price > 0 ? this.updatedBinValue.price / 100 : this.updatedBinValue.price
      this.updatedBinValue.weeklyMainFee = this.updatedBinValue.weekly_maintenance_fee ? this.updatedBinValue.weekly_maintenance_fee / 100 : this.updatedBinValue.weekly_maintenance_fee
      this.updatedBinValue.weightAllowed = this.updatedBinValue.weight_allowed
      this.updatedBinValue.chargePerTonneStatus = this.updatedBinValue.charge_per_tonne
      this.updatedBinValue.chargePerLitreStatus = this.updatedBinValue.charge_per_litre

      let moment = require('moment');
      let _moment =  new moment(this.updatedBinValue.issue_date*1000).unix()
      let date = moment(_moment).format('YYYY-MM-DD')

      this.updatedBinValue.issueDate = date
      this.editBin = !this.editBin
      this.newBin = false
    },
    async submitUpdate(){
      await this.$validator.validateAll().then((response) => {
        // console.log(response)
        if(response){
          let _binID = parseInt(this.updatedBinValue.id)
          let _price = 0
          let _weeklyMaintenanceFee = 0
          let _extraPrice = 0
          let _weightAllowed = 0
          let _issueDate = this.updatedBinValue.issueDate
          let _binIdentifier = this.updatedBinValue.binIdentifier
          let _castors = this.updatedBinValue.castorsStatus
          let _padlocks = this.updatedBinValue.padlocksStatus
          let _perLitre = this.updatedBinValue.chargePerLitreStatus
          let _perTonne = this.updatedBinValue.chargePerTonneStatus
          // console.log(_perLitre)
          // console.log(_perTonne)

          if(this.updatedBinValue.priceFormatted > 0){
            _price = parseInt(this.updatedBinValue.priceFormatted * 100)
          } else {
            _price = 0
          }

          if(this.updatedBinValue.weightAllowed) {
            _weightAllowed = parseFloat(this.updatedBinValue.weightAllowed)
          }

          if(this.updatedBinValue.extraPrice > 0){
            _extraPrice = parseInt(this.updatedBinValue.extraPrice * 100)
          }  else {
            _extraPrice = 0
          }

          if(this.updatedBinValue.weeklyMainFee > 0){
            _weeklyMaintenanceFee = parseInt(this.updatedBinValue.weeklyMainFee * 100)
          }  else {
            _weeklyMaintenanceFee = 0
          }

          this.updateServiceBin({
            binId: _binID,
            price: _price,
            binIdentifier: _binIdentifier,
            issueDate: _issueDate,
            weeklyMaintenanceFee: _weeklyMaintenanceFee,
            padlocks: _padlocks,
            castors: _castors,
            weightAllowed: _weightAllowed,
            extraPrice: _extraPrice,
            chargePerLitre: _perLitre,
            chargePerTonne: _perTonne,
          }).then((res) => {
            // console.log('res', res)
            location.reload()
          })
        }
      })
    },
    deleteCurrentBinPressed(selectedBin){
      if(this.$store.getters['auth/getUserRole'] === 'Admin') {
        this.updatedBinValue = selectedBin
        this.removeBin = !this.removeBin
      }
    },
    performDelete(){
      this.deleteServiceBin({id: parseInt(this.updatedBinValue.id)}).then(() => {
        location.reload()
      })
    },
    getMaintenanceFee(fee){
      // console.log('FEE: ' + fee);
      if (fee !== null){
        return fee / 100;
      } else {
        return 0;
      }
    },
    duplicateCurrentBin(bin){
      // console.log(bin)
      let moment = require('moment');
      let today = moment.utc().toISOString()

      // Default price if there is not a custom fee
      let defaultPrice = true
      let binPrice = bin.bin.price

      if(bin.price){
        defaultPrice = false
        binPrice = bin.price
      }

      if(bin.weight_allowed) {
        bin.weight_allowed = parseFloat(bin.weight_allowed)
      }

      if(bin.extra_price){
        bin.extra_price = parseInt(bin.extra_price)
      }

      if(bin.weekly_maintenance_fee){
        bin.weekly_maintenance_fee = parseInt(bin.weekly_maintenance_fee)
      }

      this.addBinToService({
        serviceId: this.serviceId,
        binId: bin.bin_id,
        price: binPrice,
        binIdentifier: 'To be defined',
        defaultPricing: defaultPrice,
        issueDate: today,
        weeklyMaintenanceFee: bin.weekly_maintenance_fee,
        padlocks: bin.padlocks,
        castors: bin.castors,
        weightAllowed: bin.weight_allowed,
        extraPrice: bin.extra_price,
        chargePerLitre: bin.charge_per_litre,
        chargePerTonne: bin.charge_per_tonne,
      }).then(res => {
        location.reload()
      })
    }
  },
}
</script>

<template>
  <div>
    <div class="">
      <h2 :class="$style.routeHeader">
        Bins
      </h2>
    </div>
    <VBtn
      slot="activator"
      :class="$style.addButton"
      color="blue"
      @click="newBin = !newBin"
    >
      + ADD BIN
    </VBtn>

    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="removeBin"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Are you sure you want to delete {{ updatedBinValue.id }}?</h2>
              <VLayout wrap>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="removeBin = !removeBin"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="orange"
                    block
                    @click.native="performDelete()"
                  >
                    DELETE
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>

    <VLayout style="width: 100%">
      <VFlex
        xs0
        sm12
      />
      <VFlex
        xs12
        md5
      >
        <VTextField
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        />
      </VFlex>
    </VLayout>

    <VDataTable
      :headers="binHeaders"
      :items="bin"
      :search="search"
      rows-per-page-text=""
      :rows-per-page-items="[10]"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td class="text-xs-left">
          {{ props.item.id }}
        </td>
        <td class="text-xs-left">
          {{ props.item.bin.description }}
        </td>
        <td class="text-xs-left">
          {{ props.item.bin.capacity }}
        </td>
        <td
          v-if="props.item.price"
          class="text-xs-left"
        >
          $ {{ props.item.price > 0 ? props.item.price / 100 : props.item.price }}
        </td>
        <td
          v-if="props.item.extra_price"
          class="text-xs-left"
        >
          $ {{ props.item.extra_price > 0 ? props.item.extra_price / 100 : props.item.extra_price }}
        </td>
        <td
          v-if="!props.item.extra_price || props.item.extra_price === 0"
          class="text-xs-left"
        >
          $ 0
        </td>
        <td
          v-if="!props.item.price"
          class="text-xs-left"
        >
          $ 0
        </td>
        <td
          class="text-xs-left"
        >
          $ {{ getMaintenanceFee(props.item.weekly_maintenance_fee) }}
        </td>
        <td class="justify-center layout px-0">
          <VIcon
            small
            class="mr-2"
            @click="updateBin(props.item)"
          >
            edit
          </VIcon>
          <VIcon
            small
            @click="deleteCurrentBinPressed(props.item)"
          >
            delete
          </VIcon>
          <VBtn
            slot="activator"
            style="display: block; position:relative; margin: auto auto"
            color="green"
            @click.native="duplicateCurrentBin(props.item)"
          >
            Duplicate
          </VBtn>
        </td>
      </template>
    </VDataTable>

    <AddServiceBin
      :service-id="serviceId"
      :new-bin="newBin"
    />
    <!-- Edit Service Bin MODAL -->
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="editBin"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <VFlex xs12>
                <h3>Edit Bin</h3>
              </VFlex>
              <VFlex xs12>
                <VTextField
                  v-model="updatedBinValue.priceFormatted"
                  v-validate="'required'"
                  :error-messages="errors.collect('service_fee')"
                  data-vv-name="service_fee"
                  type="number"
                  label="Service fee"
                  required
                  :menu-props="{ absolute: true }"
                  prefix="$"
                />
              </VFlex>
              <VFlex xs12>
                <VTextField
                  v-model="updatedBinValue.weeklyMainFee"
                  v-validate="'required'"
                  :error-messages="errors.collect('maintenance_fee')"
                  data-vv-name="maintenance_fee"
                  type="number"
                  label="Maintenance fee"
                  required
                  :menu-props="{ absolute: true }"
                  prefix="$"
                />
              </VFlex>
              <VFlex xs12>
                <VTextField
                  v-model="updatedBinValue.binIdentifier"
                  v-validate="'required'"
                  :error-messages="errors.collect('bin_identifier')"
                  data-vv-name="bin_identifier"
                  label="Bin Identifier"
                  required
                  :menu-props="{ absolute: true }"
                />
              </VFlex>
              <VFlex xs12>
                <VTextField
                  v-model="updatedBinValue.issueDate"
                  v-validate="'required'"
                  :error-messages="errors.collect('issue_date')"
                  data-vv-name="issue_date"
                  label="Issue Date"
                  type="date"
                  required
                  :menu-props="{ absolute: true }"
                />
              </VFlex>

              <VLayout>
                <VFlex xs6>
                  <VCheckbox
                    v-model="updatedBinValue.padlocksStatus"
                    label="Padlocks"
                  />
                </VFlex>
                <VFlex xs6>
                  <VCheckbox
                    v-model="updatedBinValue.castorsStatus"
                    label="Castors"
                  />
                </VFlex>
              </VLayout>
              <VLayout>
                <VFlex
                  xs6
                >
                  <VTextField
                    v-model="updatedBinValue.weightAllowed"
                    v-validate="'required'"
                    :error-messages="errors.collect('weight_allowed')"
                    data-vv-name="weight_allowed"
                    type="number"
                    label="Weight Allowed"
                    required
                    :menu-props="{ absolute: true }"
                  />
                </VFlex>
                <VFlex
                  xs6
                >
                  <VTextField
                    v-model="updatedBinValue.extraPrice"
                    v-validate="'required'"
                    :error-messages="errors.collect('extra_price')"
                    data-vv-name="extra_price"
                    type="number"
                    label="Extra Price"
                    required
                    :menu-props="{ absolute: true }"
                    prefix="$"
                  />
                </VFlex>
              </VLayout>
              <VLayout
                row
                wrap
              >
                <VFlex xs6>
                  <VCheckbox
                    v-model="updatedBinValue.chargePerTonneStatus"
                    label="Charge per Tonne"
                  />
                </VFlex>
                <VFlex xs6>
                  <VCheckbox
                    v-model="updatedBinValue.chargePerLitreStatus"
                    label="Charge per Litre"
                  />
                </VFlex>
              </VLayout>
              <VLayout>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="editBin = !editBin"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="submitUpdate()"
                  >
                    Save
                  </VBtn>
                </VFlex>
              </VLayout>
            </vcontainer>
          </vcardtext>
        </vcard>
      </vdialog>
    </VLayout>
  </div>
</template>

<style lang="scss" module>
    @import '@design';

    .routeHeader {
        display: inline-block;
    }

    .addButton {
        display: inline-block;
        float: right;
    }
</style>
